<mat-card>
  <app-card-header
    icono="alarm"
    [title]="title"
    [draggable]="false"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (form && !loading) {
    <form id="form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-card-content
        [class.cardContentFullscreen]="!dialogRef"
        [class.cardContentDialog]="dialogRef"
        class="card-content-crear"
      >
        <!-- Información -->
        <app-info-banner
          icon="alarm"
          color="orange"
          title="¿Cómo funcionan los recordatorios?"
          [closable]="false"
          margin="0 0 16px 0"
          message="Programá avisos de mantenimiento para tus vehículos. Cuando se cumple la condición, se notifica al destinatario elegido.
            <ul style='margin: 8px 0 0; padding-left: 18px;'>
              <li><b>Kilómetros:</b> se dispara al alcanzar el odómetro objetivo del vehículo.</li>
              <li><b>Fecha:</b> se dispara en una fecha y hora determinada.</li>
              <li><b>Repetible:</b> vuelve a generarse cada cierta cantidad de km o días.</li>
              <li><b>Categoría:</b> el tipo de mantenimiento (aceite, filtros, cubiertas, etc.).</li>
              <li><b>Destinatario (opcional):</b> el usuario que recibe la notificación.</li>
            </ul>"
        ></app-info-banner>

        <!-- Datos Básicos -->
        <app-content-card
          title="Datos del Recordatorio"
          icon="build"
          color="orange"
        >
          <section class="inputs-group">
            <!-- Cliente -->
            @if (!helper.esClienteFinal()) {
              <app-cliente-selector
                formControlName="idCliente"
                style="width: 100%"
                (clienteChange)="onClienteChange($event)"
              ></app-cliente-selector>
            }

            <!-- Vehículo -->
            <ng-select
              [items]="activos"
              bindLabel="identificacion"
              bindValue="_id"
              formControlName="idActivo"
              placeholder="Vehículo"
              [notFoundText]="'No hay vehículos creados'"
              style="width: 100%"
              multiple="false"
              searchable="true"
              appendTo="body"
            ></ng-select>

            <!-- Destinatario de la notificación -->
            <app-usuario-selector
              formControlName="idUsuario"
              style="width: 100%"
              placeholder="Destinatario de la notificación (opcional)"
            ></app-usuario-selector>
          </section>
        </app-content-card>

        <!-- Tipo y Categoría -->
        <app-content-card title="Tipo y Categoría" icon="category" color="blue">
          <section class="inputs-group column">
            <!-- Tipo como toggles -->
            <div style="width: 100%">
              <label class="field-label">Tipo de recordatorio</label>
              <div class="tipo-toggle-group">
                <button
                  type="button"
                  class="irx-chip"
                  [attr.aria-pressed]="tieneKm()"
                  (click)="toggleTipo('km')"
                >
                  <mat-icon>speed</mat-icon>
                  <span>Kilómetros</span>
                </button>
                <button
                  type="button"
                  class="irx-chip"
                  [attr.aria-pressed]="tieneFecha()"
                  (click)="toggleTipo('fecha')"
                >
                  <mat-icon>calendar_month</mat-icon>
                  <span>Fecha</span>
                </button>
              </div>
            </div>

            <!-- Categoría (campo subcategoria en el modelo) -->
            <ng-select
              [items]="subcategorias"
              formControlName="subcategoria"
              placeholder="Categoría"
              [notFoundText]="'No hay categorías disponibles'"
              style="width: 100%"
              multiple="false"
              searchable="true"
              appendTo="body"
            ></ng-select>

            <!-- Repetible -->
            @if (tieneKm() || tieneFecha()) {
              <mat-checkbox color="primary" formControlName="repetible">
                Repetible
              </mat-checkbox>
            }
          </section>
        </app-content-card>

        <!-- Configuración de Kilómetros -->
        @if (tieneKm()) {
          <app-content-card
            title="Configuración de Kilómetros"
            icon="speed"
            color="green"
          >
            <section class="inputs-group">
              @if (!repetible()) {
                <mat-form-field style="width: 100%">
                  <mat-label>Km del Mantenimiento</mat-label>
                  <mat-icon matPrefix>speed</mat-icon>
                  <input matInput formControlName="kmLimite" />
                </mat-form-field>
              } @else {
                <mat-form-field style="width: 100%">
                  <mat-label>A partir del Kilómetro</mat-label>
                  <mat-icon matPrefix>speed</mat-icon>
                  <mat-hint>
                    Km del primer recordatorio (cero es a partir del Km actual)
                  </mat-hint>
                  <input matInput formControlName="kmLimite" />
                </mat-form-field>

                <mat-form-field style="width: 100%">
                  <mat-label>Frecuencia en Km</mat-label>
                  <mat-icon matPrefix>repeat</mat-icon>
                  <mat-hint>Cada cuántos km</mat-hint>
                  <input matInput formControlName="frecuenciaKm" />
                </mat-form-field>
              }
            </section>
          </app-content-card>
        }

        <!-- Configuración de Fecha -->
        @if (tieneFecha()) {
          <app-content-card
            title="Configuración de Fecha"
            icon="calendar_month"
            color="teal"
          >
            <section class="inputs-group">
              @if (!repetible()) {
                <mat-form-field style="width: 100%">
                  <mat-label>Fecha y Hora</mat-label>
                  <input
                    readonly
                    matInput
                    [owlDateTime]="dtPicker"
                    [min]="minDate"
                    formControlName="fechaLimite"
                  />
                  <mat-icon matPrefix>event</mat-icon>
                  <mat-hint>DD/MM/YYYY HH:mm</mat-hint>
                  <button
                    irxBotonIcono
                    tooltip="Elegir fecha"
                    tono="primario"
                    matSuffix
                    [owlDateTimeTrigger]="dtPicker"
                    type="button"
                  >
                    <mat-icon>calendar_month</mat-icon>
                  </button>
                </mat-form-field>
                <owl-date-time #dtPicker [pickerType]="'both'"></owl-date-time>
              } @else {
                <mat-form-field style="width: 100%">
                  <mat-label>Fecha Inicial</mat-label>
                  <input
                    readonly
                    matInput
                    [owlDateTime]="dtPickerRepetible"
                    [min]="minDate"
                    formControlName="fechaLimite"
                  />
                  <mat-icon matPrefix>event</mat-icon>
                  <mat-hint>DD/MM/YYYY HH:mm</mat-hint>
                  <button
                    irxBotonIcono
                    tooltip="Elegir fecha"
                    tono="primario"
                    matSuffix
                    [owlDateTimeTrigger]="dtPickerRepetible"
                    type="button"
                  >
                    <mat-icon>calendar_month</mat-icon>
                  </button>
                </mat-form-field>
                <owl-date-time
                  #dtPickerRepetible
                  [pickerType]="'both'"
                ></owl-date-time>

                <mat-form-field style="width: 100%">
                  <mat-label>Frecuencia en Días</mat-label>
                  <mat-icon matPrefix>repeat</mat-icon>
                  <mat-hint>Cada cuántos días</mat-hint>
                  <input matInput formControlName="frecuenciaDia" />
                </mat-form-field>
              }
            </section>
          </app-content-card>
        }

        <!-- Detalles -->
        <app-content-card title="Detalles" icon="description" color="purple">
          <section class="inputs-group">
            <mat-form-field style="width: 100%">
              <mat-label>Detalles del Mantenimiento</mat-label>
              <mat-icon matPrefix>notes</mat-icon>
              <input matInput formControlName="detallesDelMantenimiento" />
            </mat-form-field>
          </section>
        </app-content-card>
      </mat-card-content>

      <mat-divider></mat-divider>

      <!-- Botones -->
      <mat-card-actions class="actions-create">
        <app-button
          matType="mat-fab extended"
          color="neutral"
          (click)="this.helper.volver()"
          text="Cancelar"
          icon="close"
        ></app-button>

        <app-button
          matType="mat-fab extended"
          [disabled]="!this.form.valid || loading"
          color="primary"
          text="Guardar"
          icon="save"
          type="submit"
        ></app-button>
      </mat-card-actions>
    </form>
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
